import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

// 用户界面
import Register from './views/register.vue'
import News from './views/user_file/news.vue';
import CompanySet from './views/user_file/companySet.vue'
import Complinance from './views/user_file/complinance.vue'
import DataTotal from './views/user_file/dataTotal.vue'
import Param from './views/user_file/param.vue'
import PermissionUser from './views/user_file/permission.vue'
import RoleUser from './views/user_file/role.vue'
import SaveContent from './views/user_file/saveContent.vue'
import Usertwo from './views/user_file/user.vue'
import setCompanyInformation from './views/setInformation/setCompanyInformation.vue'
import authorization from './views/setInformation/authorization.vue'
import Api from './views/user_file/api.vue'
import Source from './views/user_file/source.vue'
import Advertising from './views/user_file/advertising.vue'
import CrmConfig from './views/user_file/crmConfig.vue'
import CustomerLevel from './views/user_file/customerLevel.vue'
import Product from './views/user_file/product.vue'
import ProductCategory from './views/user_file/productCategory.vue'
import KeySet from './views/user_file/keySet.vue'
import Flow from './views/user_file/flow.vue'
import Examine from './views/user_file/examine.vue'
import LeadesPool from './views/user_file/leadesPool.vue'
import SetField from './views/user_file/setField.vue'
import Order from './views/user_file/order.vue'
import CustomerLists from './views/user_file/customerLists.vue'
import CustomerDetail from './views/user_file/customerDetail.vue'
import ParamBinbing from './views/user_file/paramBinbing.vue'
import AssingUser from './views/user_file/assingUser.vue'
import AdminManagement from './views/user_file/adminManagement.vue'
import AdminLabel from './views/user_file/adminLabel.vue'
import ClientBaseList from './views/user_file/clientBaseList.vue'
import GroupWelcome from './views/user_file/groupWelcome.vue'
import GroupWelcomeDetail from './views/user_file/groupWelcomeDetail.vue'
import ProductData from './views/user_file/productData.vue'
import RunoffAdmin from './views/user_file/runoffAdmin.vue'
import RunoffRemind from './views/user_file/runoffRemind.vue'
import SelfGroup from './views/user_file/selfGroup.vue'
import SelfGroupDetail from './views/user_file/selfGroupDetail.vue'
import Circle from './views/user_file/circle.vue'
import Circleadd from './views/user_file/circleadd.vue'
import Circledetails from './views/user_file/circledetails.vue'
import CircleFriend from './views/user_file/circleFriend.vue'
import CircleFriendadd from './views/user_file/circleFriendadd.vue'
import CustomerPhone from './views/user_file/customerPhone.vue'
import Login from './views/user_file/login.vue'
import Logins from './views/user_file/logins.vue'
import CustomerPhoneadd from './views/user_file/customerPhoneadd.vue'
import Friend from './views/user_file/friend.vue'
import CircleFriends from './views/user_file/circleFriends.vue'
import ActiveCode from './views/user_file/activeCode.vue'
import ActiveCodeTotal from './views/user_file/activeCodeTotal.vue'
import ActiveCodeADD from './views/user_file/activeCodeADD.vue'
import ActiveCodeCumpile from './views/user_file/activeCodeCumpile.vue'
import Organization from './views/user_file/organization.vue'
import Applys from './views/user_file/applys.vue'
import Applysadd from './views/user_file/applysadd.vue'
import DataTotaladd from './views/user_file/dataTotaladd.vue'
import DepartureInheritance from './views/user_file/departureInheritance.vue'
import departureInheritanceDetail from './views/user_file/departureInheritanceDetail.vue'
import departureInheritanceList from './views/user_file/departureInheritanceList.vue'
import departureInheritanceState from './views/user_file/departureInheritanceState.vue'
import DepartureInheritance2 from './views/user_file/departureInheritance2.vue'
import departureInheritanceDetail2 from './views/user_file/departureInheritanceDetail2.vue'
import departureInheritanceGroup from './views/user_file/departureInheritanceGroup.vue'
import departureInheritanceList2 from './views/user_file/departureInheritanceList2.vue'
import departureInheritanceState2 from './views/user_file/departureInheritanceState2.vue'
import dataAnalysis from './views/user_file/dataAnalysis.vue';
import historyFriends from './views/user_file/historyFriends.vue';
import fissionTools from './views/user_file/fissionTools.vue';
import fissionToolsAdd from './views/user_file/fissionToolsAdd.vue';
import fissionToolsDetail from './views/user_file/fissionToolsDetail.vue';
import fissionAssistant from './views/user_file/fissionAssistant.vue';
import fissionParticipate from './views/user_file/fissionParticipate.vue';
import groupTags from './views/user_file/groupTags.vue';
import clientBaseDetail from './views/user_file/clientBaseDetail.vue';
import setGroups from './views/user_file/setGroups.vue';
import setGroupsDetail from './views/user_file/setGroupsDetail.vue';
import tagSetGroup from './views/user_file/tagSetGroup.vue';
import tagSetGroupDetail from './views/user_file/tagSetGroupDetail.vue';
import customerCode from './views/user_file/customerCode.vue';
import customerCodeAdd from './views/user_file/customerCodeAdd.vue';
import customerCodeDetail from './views/user_file/customerCodeDetail.vue';
import friendSop from './views/user_file/friendSop.vue';
import friendSopDetail from './views/user_file/friendSopDetail.vue';
import friendsPoster from './views/user_file/friendsPoster.vue';
import friendsPosterDetail from './views/user_file/friendsPosterDetail.vue';
import groupSop from './views/user_file/groupSop.vue';
import groupSopDetail from './views/user_file/groupSopDetail.vue';
import cardContent from './views/user_file/cardContent.vue';
import cardSearch from './views/user_file/cardSearch.vue';
import cardStatics from './views/user_file/cardStatics.vue';
import cardStaticsUser from './views/user_file/cardStaticsUser.vue';
import selfApplication from './views/user_file/selfApplication.vue';
import clientFriendTask from './views/user_file/clientFriendTask.vue';
import clientFriendTaskDetail from './views/user_file/clientFriendTaskDetail.vue';
import bingBublicAccount from './views/user_file/bingBublicAccount.vue';
import transitPage from './views/user_file/transitPage.vue';
import customerServiceList from './views/user_file/customerServiceList.vue';
import receptionStaffList from './views/user_file/receptionStaffList.vue';
import departmentStaffList from './views/user_file/departmentStaffList.vue';
import customerServiceWelcome from './views/user_file/customerServiceWelcome.vue';
import customerServiceWelcomeAdd from './views/user_file/customerServiceWelcomeAdd.vue'
import selfMenus from './views/user_file/selfMenus.vue'

// 代理后台用户
import Home from './views/Home.vue'
import Reg from './views/Reg.vue'
import Zhmm from './views/zhmm.vue'
import mine from './views/mine.vue'
import Zdaili from './views/Zdaili.vue'
import DaiHoutaifenpei from './views/daili/about/houtaifenpei.vue'
import DaiWodeziliao from './views/daili/about/wodeziliao.vue'
import DaiYichengjiao from './views/daili/about/yichengjiao.vue'
import DaiYufufei from './views/daili/about/yufufu.vue'
import DaHome from './views/daili/about/dahome.vue'
import Resources from './views/daili/about/resources.vue'
import DaRole from './views/daili/about/tali.vue'
import DaiDaililieb from './views/daili/about/dailileb.vue'
import NotiCe from './views/daili/about/notice.vue'
import Money from './views/daili/about/money.vue'
import Apply from './views/daili/about/apply.vue'
import Invoice from './views/daili/about/invoice.vue'
import Invoicedss from './views/daili/about/invoicedss.vue'
import Invoiceand from './views/daili/about/invoiceand.vue'
import Invoiceadd from './views/daili/about/invoiceadd.vue'
import Invoiceadds from './views/daili/about/invoiceadds.vue'
import InvoiceParticulars from './views/daili/about/invoiceParticulars.vue'
import DahomeNewest from './views/daili/about/dahomeNewest.vue'
import DahomeNewestlist from './views/daili/about/dahomeNewestlist.vue'
import Knowledge from './views/daili/about/knowledge.vue'
import Knowledgeadd from './views/daili/about/knowledgeadd.vue'
//总代理后台路由
import ZdaiApi from './views/zdaili/about/api.vue'
import Zdaichuzi from './views/zdaili/about/dailichuzhi.vue'
import ZdaiDaililb from './views/zdaili/about/daililb.vue'
import ZdaiDailiyeji from './views/zdaili/about/dailiyeji.vue'
import ZdaiGrade from './views/zdaili/about/grade.vue'
import ZdaiJichushez from './views/zdaili/about/jichushez.vue'
import ZdaiLiebiao from './views/zdaili/about/liebiao.vue'
import ZdaiQuanguan from './views/zdaili/about/quanguan.vue'
import ZdaiShouye from './views/zdaili/about/shouye.vue'
import Role from './views/zdaili/about/role.vue'
import Permission from './views/zdaili/about/permission.vue'
import management from './views/zdaili/about/management.vue'
import Notice from './views/zdaili/about/notice.vue'
import Seasuser from './views/zdaili/about/seasuser.vue'
import Record from './views/zdaili/about/record.vue'
import ApiWchat from './views/zdaili/about/apiWchat.vue'
import UseConfiguration from './views/zdaili/about/useConfiguration.vue'
import NewWelcome from './views/zdaili/about/newWelcome.vue'
import NewWelcomeAdd from './views/zdaili/about/newWelcomeAdd.vue'
import NewCustomerWelcome from './views/zdaili/about/newCustomerWelcome.vue'
import NewCustomerWelcomeAdd from './views/zdaili/about/newCustomerWelcomeAdd.vue'
import MaterialAdmin from './views/zdaili/about/materialAdmin.vue'
import MaterialAdminDetail from './views/zdaili/about/materialAdminDetail.vue'
import MaterialAdminCircle from './views/zdaili/about/materialAdminCircle.vue'
import MaterialAdminDetailCircle from './views/zdaili/about/materialAdminDetailCircle.vue'
import MaterialAdminGroup from './views/zdaili/about/materialAdminGroup.vue'
import MaterialAdminDetailGroup from './views/zdaili/about/materialAdminDetailGroup.vue'
import sendChat from './views/zdaili/about/sendChat.vue'
import GroupSend from './views/zdaili/about/groupSend.vue'
import GroupSendDetail from './views/zdaili/about/groupSendDetail.vue'
import groupSendAdd from './views/zdaili/about/groupSendAdd.vue'
import groupSendList from './views/zdaili/about/groupSendList.vue'
import AddressBook from './views/zdaili/about/addressBook.vue'
import InvoiceList from './views/zdaili/about/invoiceList.vue'
import InvoiceListadd from './views/zdaili/about/invoiceListadd.vue'
import InvoiceListadds from './views/zdaili/about/invoiceListadds.vue'
import NoticesCategory from './views/zdaili/about/noticesCategory.vue'

// pc crm 路由
// import PcCrm from './views/PCcrm.vue'

Vue.use(Router)
const router = new Router({
    hash: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'register',
            component: Register,
            meta: {
                title: "用户登录"
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: "登录中"
            }
        },
        {
            path: '/logins',
            name: 'logins',
            component: Logins,
            meta: {
                title: "登录中"
            }
        },
        {
            path: '/posterDesign',
            name: 'posterDesign',
            component: () =>
                import ( /* webpackChunkName: "posterDesign" */ './views/pageDesign/index.vue'),
            meta: {
                title: "海报编辑器"
            }
        },
        {
            path: '/friend',
            name: 'friend',
            component: Friend,
            meta: {
                title: "查看客户详情"
            }
        },
        {
            path: '/circle',
            name: 'circle',
            component: Circle,
            meta: {
                title: "朋友圈"
            }
        },
        {
            path: '/circleadd',
            name: 'circleadd',
            component: Circleadd,
            meta: {
                title: "朋友圈"
            }
        },
        {
            path: '/circledetails',
            name: 'circledetails',
            component: Circledetails,
            meta: {
                title: "详情"
            }
        },
        {
            path: '/reg',
            name: 'reg',
            component: Reg,
            meta: {
                title: "注册"
            }
        },
        {
            path: '/zhmm',
            name: 'zhmm',
            component: Zhmm,
            meta: {
                title: "找回密码"
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                title: "用户登录"
            }
        },
        {
            path: '/setCompanyInformation',
            name: "setCompanyInformation",
            component: setCompanyInformation,
            meta: {
                title: "信息注册"
            }
        },
        {
            path: '/authorization',
            name: "authorization",
            component: authorization,
            meta: {
                title: "信息注册"
            }
        },
        {
            path: '/sendChat',
            name: "sendChat",
            component: sendChat,
            meta: {
                title: "答复"
            }
        },
        {
            path: '/register/user',
            name: 'user',
            // route level code-splitting 
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.DaiDaililieb /mine/agency/resources
            component: () =>
                import ('./views/user.vue'),
            meta: {
                title: "用户页面"
            },
            children: [{
                    path: '/register/user/dataTotaladd',
                    name: "dataTotaladd",
                    component: DataTotaladd,
                    meta: {
                        title: "公告详情"
                    }
                },
                {
                    path: '/register/user/news',
                    name: "news",
                    component: News,
                    meta: {
                        title: "公告列表"
                    }
                },
                {
                    path: '/register/user/cardContent',
                    name: "cardContent",
                    component: cardContent,
                    meta: {
                        title: "文案库"
                    }
                },
                {
                    path: '/register/user/cardSearch',
                    name: "cardSearch",
                    component: cardSearch,
                    meta: {
                        title: "名片管理"
                    }
                },
                {
                    path: '/register/user/cardStatics',
                    name: "cardStatics",
                    component: cardStatics,
                    meta: {
                        title: "数据分析"
                    }
                },
                {
                    path: '/register/user/cardStaticsUser',
                    name: "cardStaticsUser",
                    component: cardStaticsUser,
                    meta: {
                        title: "数据分析"
                    }
                },
                {
                    path: '/register/user/applysadd',
                    name: "applysadd",
                    component: Applysadd,
                    meta: {
                        title: "报销审批流程"
                    }
                },
                {
                    path: '/register/user/applys',
                    name: "applys",
                    component: Applys,
                    meta: {
                        title: "报销审批流程"
                    }
                },
                {
                    path: '/register/user/activeCodeCumpile',
                    name: "activeCodeCumpile",
                    component: ActiveCodeCumpile,
                    meta: {
                        title: "编辑渠道二维码"
                    }
                },
                {
                    path: '/register/user/organization',
                    name: "organization",
                    component: Organization,
                    meta: {
                        title: "架构设置"
                    }
                },

                {
                    path: '/register/user/activeCodeADD',
                    name: "activeCodeADD",
                    component: ActiveCodeADD,
                    meta: {
                        title: "新建渠道二维码"
                    }
                },
                {
                    path: '/register/user/activeCodeTotal',
                    name: "activeCodeTotal",
                    component: ActiveCodeTotal,
                    meta: {
                        title: "数据统计"
                    }
                },
                {
                    path: '/register/user/activeCode',
                    name: "activeCode",
                    component: ActiveCode,
                    meta: {
                        title: "渠道活码列表"
                    }
                },
                {
                    path: '/register/user/circleFriends',
                    name: "circleFriends",
                    component: CircleFriends,
                    meta: {
                        title: "所有企业圈列表"
                    }
                },
                {
                    path: '/register/user/customerPhoneadd',
                    name: "customerPhoneadd",
                    component: CustomerPhoneadd,
                    meta: {
                        title: "好友详情"
                    }
                },
                {
                    path: '/register/user/customerPhone',
                    name: "customerPhone",
                    component: CustomerPhone,
                    meta: {
                        title: "批量添加好友"
                    }
                },
                {
                    path: '/register/user/circleFriendadd',
                    name: "circleFriendadd",
                    component: CircleFriendadd,
                    meta: {
                        title: "朋友圈列表"
                    }
                },
                {
                    path: '/register/user/circleFriend',
                    name: "circleFriend",
                    component: CircleFriend,
                    meta: {
                        title: "朋友圈管理"
                    }
                },
                {
                    path: '/register/user/adminManagement',
                    name: "adminManagement",
                    component: AdminManagement,
                    meta: {
                        title: "客户管理"
                    }
                },
                {
                    path: '/register/user/adminLabel',
                    name: "adminLabel",
                    component: AdminLabel,
                    meta: {
                        title: "客户标签"
                    }
                },
                {
                    path: '/register/user/clientBaseList',
                    name: "clientBaseList",
                    component: ClientBaseList,
                    meta: {
                        title: "客户群列表"
                    }
                },
                {
                    path: '/register/user/groupWelcome',
                    name: "groupWelcome",
                    component: GroupWelcome,
                    meta: {
                        title: "群欢迎语"
                    }
                },
                {
                    path: '/register/user/groupWelcomeDetail',
                    name: "groupWelcomeDetail",
                    component: GroupWelcomeDetail,
                    meta: {
                        title: "新增群欢迎语"
                    }
                },
                {
                    path: '/register/user/productData',
                    name: "productData",
                    component: ProductData,
                    meta: {
                        title: "成员群数据"
                    }
                },
                {
                    path: '/register/user/setGroups',
                    name: "setGroups",
                    component: setGroups,
                    meta: {
                        title: "自动拉群"
                    }
                },
                {
                    path: '/register/user/setGroupsDetail',
                    name: "setGroupsDetail",
                    component: setGroupsDetail,
                    meta: {
                        title: "自动拉群详情"
                    }
                },
                {
                    path: '/register/user/tagSetGroup',
                    name: "tagSetGroup",
                    component: tagSetGroup,
                    meta: {
                        title: "标签拉群"
                    }
                },
                {
                    path: '/register/user/tagSetGroupDetail',
                    name: "tagSetGroupDetail",
                    component: tagSetGroupDetail,
                    meta: {
                        title: "标签拉群详情"
                    }
                },
                {
                    path: '/register/user/customerCode',
                    name: "customerCode",
                    component: customerCode,
                    meta: {
                        title: "客户群活码"
                    }
                },
                {
                    path: '/register/user/customerCodeAdd',
                    name: "customerCodeAdd",
                    component: customerCodeAdd,
                    meta: {
                        title: "新建群活码"
                    }
                },
                {
                    path: '/register/user/customerCodeDetail',
                    name: "customerCodeDetail",
                    component: customerCodeDetail,
                    meta: {
                        title: "群活码详情"
                    }
                },
                {
                    path: '/register/user/friendSop',
                    name: "friendSop",
                    component: friendSop,
                    meta: {
                        title: "朋友圈SOP"
                    }
                },
                {
                    path: '/register/user/friendSopDetail',
                    name: "friendSopDetail",
                    component: friendSopDetail,
                    meta: {
                        title: "朋友圈SOP详情"
                    }
                },
                {
                    path: '/register/user/friendsPoster',
                    name: "friendsPoster",
                    component: friendsPoster,
                    meta: {
                        title: "海报设计"
                    }
                },
                {
                    path: '/register/user/friendsPosterDetail',
                    name: "friendsPosterDetail",
                    component: friendsPosterDetail,
                    meta: {
                        title: "海报设计"
                    }
                },
                {
                    path: '/register/user/groupSop',
                    name: "groupSop",
                    component: groupSop,
                    meta: {
                        title: "群SOP"
                    }
                },
                {
                    path: '/register/user/groupSopDetail',
                    name: "groupSopDetail",
                    component: groupSopDetail,
                    meta: {
                        title: "群SOP详情"
                    }
                },
                {
                    path: '/register/user/runoffAdmin',
                    name: "runoffAdmin",
                    component: RunoffAdmin,
                    meta: {
                        title: "流失客户"
                    }
                },
                {
                    path: '/register/user/runoffRemind',
                    name: "runoffRemind",
                    component: RunoffRemind,
                    meta: {
                        title: "流失提醒"
                    }
                },
                {
                    path: '/register/user/selfGroup',
                    name: "selfGroup",
                    component: SelfGroup,
                    meta: {
                        title: "自动拉群"
                    }
                },
                {
                    path: '/register/user/selfGroupDetail',
                    name: "selfGroupDetail",
                    component: SelfGroupDetail,
                    meta: {
                        title: "新建拉群"
                    }
                },
                {
                    path: '/register/user/newWelcome',
                    name: "newWelcome",
                    component: NewWelcome,
                    meta: {
                        title: "新客欢迎语"
                    }
                },
                {
                    path: '/register/user/newWelcomeAdd',
                    name: "NewWelcomeAdd",
                    component: NewWelcomeAdd,
                    meta: {
                        title: "添加欢迎语"
                    }
                },
                {
                    path: '/register/user/newCustomerWelcome',
                    name: "newCustomerWelcome",
                    component: NewCustomerWelcome,
                    meta: {
                        title: "新客欢迎语"
                    }
                },
                {
                    path: '/register/user/newCustomerWelcomeAdd',
                    name: "newCustomerWelcomeAdd",
                    component: NewCustomerWelcomeAdd,
                    meta: {
                        title: "添加新客欢迎语"
                    }
                },
                {
                    path: '/register/user/materialAdmin',
                    name: "materialAdmin",
                    component: MaterialAdmin,
                    meta: {
                        title: "话术管理"
                    }
                },
                {
                    path: '/register/user/momentsMaterial',
                    name: "materialAdminCircle",
                    component: MaterialAdminCircle,
                    meta: {
                        title: "朋友圈素材管理"
                    }
                },
                {
                    path: '/register/user/groupMaterial',
                    name: "materialAdminGroup",
                    component: MaterialAdminGroup,
                    meta: {
                        title: "群素材管理"
                    }
                },
                {
                    path: '/register/user/groupTags',
                    name: "groupTags",
                    component: groupTags,
                    meta: {
                        title: "群标签"
                    }
                },
                {
                    path: '/register/user/materialAdminDetail',
                    name: "materialAdminDetail",
                    component: MaterialAdminDetail,
                    meta: {
                        title: "新建素材"
                    },
                },
                {
                    path: '/register/user/materialAdminDetailCircle',
                    name: "materialAdminDetailCircle",
                    component: MaterialAdminDetailCircle,
                    meta: {
                        title: "新建素材"
                    },
                },
                {
                    path: '/register/user/materialAdminDetailGroup',
                    name: "materialAdminDetailGroup",
                    component: MaterialAdminDetailGroup,
                    meta: {
                        title: "新建素材"
                    },
                },
                {
                    path: '/register/user/groupSend',
                    name: "groupSend",
                    component: GroupSend,
                    meta: {
                        title: "群发消息"
                    }
                },
                {
                    path: '/register/user/groupSendDetail',
                    name: "groupSendDetail",
                    component: GroupSendDetail,
                    meta: {
                        title: "添加群发消息"
                    }
                },
                {
                    path: '/register/user/groupSendList',
                    name: "groupSendList",
                    component: groupSendList,
                    meta: {
                        title: "群发消息列表"
                    }
                },
                {
                    path: '/register/user/groupSendAdd',
                    name: "groupSendAdd",
                    component: groupSendAdd,
                    meta: {
                        title: "新建群发消息"
                    }
                },
                {
                    path: '/register/user/addressBook',
                    name: "addressBook",
                    component: AddressBook,
                    meta: {
                        title: "通讯录管理"
                    }
                },
                {
                    path: '/register/user/fissionTools',
                    name: "fissionTools",
                    component: fissionTools,
                    meta: {
                        title: "裂变工具"
                    }
                },
                {
                    path: '/register/user/fissionToolsAdd',
                    name: "fissionToolsAdd",
                    component: fissionToolsAdd,
                    meta: {
                        title: "裂变工具"
                    }
                },
                {
                    path: '/register/user/fissionToolsDetail',
                    name: "fissionToolsDetail",
                    component: fissionToolsDetail,
                    meta: {
                        title: "裂变工具"
                    }
                },
                {
                    path: '/register/user/fissionAssistant',
                    name: "fissionAssistant",
                    component: fissionAssistant,
                    meta: {
                        title: "参与者"
                    }
                },
                {
                    path: '/register/user/fissionParticipate',
                    name: "fissionParticipate",
                    component: fissionParticipate,
                    meta: {
                        title: "助力记录"
                    }
                },
                {
                    path: '/register/user/departureInheritance',
                    name: "departureInheritance",
                    component: DepartureInheritance,
                    meta: {
                        title: "离职继承"
                    }
                },
                {
                    path: '/register/user/departureInheritanceDetail',
                    name: "departureInheritanceDetail",
                    component: departureInheritanceDetail,
                    meta: {
                        title: "离职继承"
                    }
                },
                {
                    path: '/register/user/departureInheritanceList',
                    name: "departureInheritanceList",
                    component: departureInheritanceList,
                    meta: {
                        title: "继承列表"
                    }
                },
                {
                    path: '/register/user/departureInheritanceState',
                    name: "departureInheritanceState",
                    component: departureInheritanceState,
                    meta: {
                        title: "接替状态"
                    }
                },
                {
                    path: '/register/user/departureInheritance2',
                    name: "departureInheritance2",
                    component: DepartureInheritance2,
                    meta: {
                        title: "在职继承"
                    }
                },
                {
                    path: '/register/user/departureInheritanceDetail2',
                    name: "departureInheritanceDetail2",
                    component: departureInheritanceDetail2,
                    meta: {
                        title: "在职继承"
                    }
                },
                {
                    path: '/register/user/departureInheritanceGroup',
                    name: "departureInheritanceGroup",
                    component: departureInheritanceGroup,
                    meta: {
                        title: "分配群"
                    }
                },
                {
                    path: '/register/user/departureInheritanceList2',
                    name: "departureInheritanceList2",
                    component: departureInheritanceList2,
                    meta: {
                        title: "继承列表"
                    }
                },
                {
                    path: '/register/user/departureInheritanceState2',
                    name: "departureInheritanceState2",
                    component: departureInheritanceState2,
                    meta: {
                        title: "接替状态"
                    }
                },
                {
                    path: '/register/user/useConfiguration',
                    name: "useConfiguration",
                    component: UseConfiguration,
                    meta: {
                        title: "聊天工具栏"
                    }
                },
                {
                    path: '/register/user/historyFriends',
                    name: "historyFriends",
                    component: historyFriends,
                    meta: {
                        title: "历史朋友圈"
                    }
                },
                {
                    path: '/register/user/assingUser',
                    name: "assingUser",
                    component: AssingUser,
                    meta: {
                        title: "分配可用员工"
                    }
                },
                {
                    path: '/register/user/paramBinbing',
                    name: "paramBinbing",
                    component: ParamBinbing,
                    meta: {
                        title: "参数绑定"
                    }
                },
                {
                    path: '/register/user/customerLists',
                    name: "customerLists",
                    component: CustomerLists,
                    meta: {
                        title: "客户列表"
                    }
                },
                {
                    path: '/register/user/dataAnalysis',
                    name: "dataAnalysis",
                    component: dataAnalysis,
                    meta: {
                        title: "社群营销-群数据分析"
                    }
                },
                {
                    path: '/register/user/customerDetail',
                    name: "customerDetail",
                    component: CustomerDetail,
                    meta: {
                        title: "客户详情"
                    }
                },
                {
                    path: '/register/user/order',
                    name: "order",
                    component: Order,
                    meta: {
                        title: "订单列表"
                    }
                },
                {
                    path: '/register/user/setField',
                    name: "setField",
                    component: SetField,
                    meta: {
                        title: "自定义字段配置"
                    }
                },
                {
                    path: '/register/user/leadesPool',
                    name: "leadesPool",
                    component: LeadesPool,
                    meta: {
                        title: "线索池"
                    }
                },
                {
                    path: '/register/user/examine',
                    name: "userExamine",
                    component: Examine,
                    meta: {
                        title: "审批流程"
                    }
                },
                {
                    path: '/register/user/flow',
                    component: Flow,
                    meta: {
                        title: "合同审批流程"
                    }
                },
                {
                    path: '/register/user/keySet',
                    component: KeySet,
                    meta: {
                        title: "KPI设置"
                    }
                },
                {
                    path: '/register/user/productCategory',
                    component: ProductCategory,
                    meta: {
                        title: "产品分类"
                    }
                },
                {
                    path: '/register/user/product',
                    component: Product,
                    meta: {
                        title: "产品模块"
                    }
                },
                {
                    path: '/register/user/customerLevel',
                    component: CustomerLevel,
                    meta: {
                        title: "客户级别管理"
                    }
                },
                {
                    path: '/register/user/crmConfig',
                    component: CrmConfig,
                    meta: {
                        title: "参数配置"
                    }
                },
                {
                    path: '/register/user/advertising',
                    component: Advertising,
                    meta: {
                        title: "发布公告"
                    }
                },
                {
                    path: '/register/user/source',
                    component: Source,
                    meta: {
                        title: "线索来源管理"
                    }
                },
                {
                    path: '/register/user/companySet',
                    component: CompanySet,
                    meta: {
                        title: "企业信息设置"
                    }
                },
                {
                    path: '/register/user/complinance',
                    component: Complinance,
                    meta: {
                        title: "合规监控"
                    }
                },
                {
                    path: '/register/user/dataTotal',
                    component: DataTotal,
                    meta: {
                        title: "数据统计"
                    }
                },
                {
                    path: '/register/user/param',
                    component: Param,
                    meta: {
                        title: "参数配置"
                    }
                },
                {
                    path: '/register/user/customerServiceList',
                    component: customerServiceList,
                    meta: {
                        title: "客服列表"
                    }
                },
                {
                    path: '/register/user/receptionStaffList',
                    component: receptionStaffList,
                    meta: {
                        title: "接待人员列表"
                    }
                },
                {
                    path: '/register/user/departmentStaffList',
                    component: departmentStaffList,
                    meta: {
                        title: "接待部门列表"
                    }
                },
                {
                    path: '/register/user/customerServiceWelcome',
                    component: customerServiceWelcome,
                    meta: {
                        title: "客服欢迎语"
                    }
                },
                {
                    path: '/register/user/customerServiceWelcomeAdd',
                    name: 'customerServiceWelcomeAdd',
                    component: customerServiceWelcomeAdd,
                    meta: {
                        title: "新建客服欢迎语"
                    }
                },
                {
                    path: '/register/user/permission',
                    component: PermissionUser,
                    meta: {
                        title: "权限列表"
                    }
                },
                {
                    path: '/register/user/role',
                    component: RoleUser,
                    meta: {
                        title: "角色列表"
                    }
                },
                {
                    path: '/register/user/saveContent',
                    component: SaveContent,
                    meta: {
                        title: "内容存档"
                    }
                },
                {
                    path: '/register/user/user',
                    component: Usertwo,
                    meta: {
                        title: "系统管理员"
                    }
                },
                {
                    path: '/register/user/api',
                    component: Api,
                    meta: {
                        title: "系统管理员"
                    }
                },
                {
                    path: '/register/user/clientBaseDetail',
                    name: 'clientBaseDetail',
                    component: clientBaseDetail,
                    meta: {
                        title: "群详情"
                    }
                },
                {
                    path: '/register/user/selfApplication',
                    name: 'selfApplication',
                    component: selfApplication,
                    meta: {
                        title: "自建应用"
                    }
                },
                {
                    path: '/register/user/clientFriendTask',
                    name: 'clientFriendTask',
                    component: clientFriendTask,
                    meta: {
                        title: "朋友圈任务"
                    }
                },
                {
                    path: '/register/user/clientFriendTaskDetail',
                    name: 'clientFriendTaskDetail',
                    component: clientFriendTaskDetail,
                    meta: {
                        title: "朋友圈任务详情"
                    }
                },
                {
                    path: '/register/user/bingBublicAccount',
                    name: 'bingBublicAccount',
                    component: bingBublicAccount,
                    meta: {
                        title: "绑定公众号"
                    }
                },
                {
                    path: '/register/user/transitPage',
                    name: 'transitPage',
                    component: transitPage,
                    meta: {
                        title: "中转页面"
                    }
                },
                {
                    path: '/register/user/appStore',
                    name: 'appStore',
                    component: () =>
                        import ('./views/user_file/appStore.vue'),
                    meta: {
                        title: "应用市场"
                    }
                },
                {
                    path: '/register/user/wmhome',
                    name: 'wmhome',
                    component: () =>
                        import ('./views/user_file/weimeng/home.vue'),
                    meta: {
                        title: "概况"
                    }
                },
                {
                    path: '/register/user/goodsList',
                    name: 'goodsList',
                    component: () =>
                        import ('./views/user_file/weimeng/goodsList.vue'),
                    meta: {
                        title: "全部商品"
                    }
                },
                {
                    path: '/register/user/selfList',
                    name: 'selfList',
                    component: () =>
                        import ('./views/user_file/weimeng/selfList.vue'),
                    meta: {
                        title: "自提点列表"
                    }
                },
                {
                    path: '/register/user/goodsGroup',
                    name: 'goodsGroup',
                    component: () =>
                        import ('./views/user_file/weimeng/goodsGroup.vue'),
                    meta: {
                        title: "商品分组"
                    }
                },
                {
                    path: '/register/user/customerlist',
                    name: 'customerlist',
                    component: () =>
                        import ('./views/user_file/weimeng/customerlist.vue'),
                    meta: {
                        title: "全部客户"
                    }
                },
                {
                    path: '/register/user/customerlabelMag',
                    name: 'customerlabelMag',
                    component: () =>
                        import ('./views/user_file/weimeng/customerlabelMag.vue'),
                    meta: {
                        title: "客户标签"
                    }
                },
                {
                    path: '/register/user/orderlist',
                    name: 'orderlist',
                    component: () =>
                        import ('./views/user_file/weimeng/orderlist.vue'),
                    meta: {
                        title: "全部订单"
                    }
                },
                {
                    path: '/register/user/orderdetail',
                    name: 'orderdetail',
                    component: () =>
                        import ('./views/user_file/weimeng/orderdetail.vue'),
                    meta: {
                        title: "订单详情"
                    }
                },
                {
                    path: '/register/user/storelist',
                    name: 'storelist',
                    component: () =>
                        import ('./views/user_file/weimeng/storeList.vue'),
                    meta: {
                        title: "店铺"
                    }
                },
                {
                    path: '/register/user/setFieldOrderMenu',
                    name: 'selfMenus',
                    component: selfMenus,
                    meta: {
                        title: "自定义菜单"
                    }
                },
            ]
        },
        {
            path: '/mine',
            name: 'mine',
            component: mine,
            meta: {
                title: "代理商登录"
            }
        },
        {
            path: '/mine/agency',
            name: 'daili',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.DaiDaililieb /mine/agency/resources
            component: () =>
                import ('./views/daili.vue'),
            meta: {
                title: "代理商"
            },
            children: [{
                    path: '/mine/agency/knowledgeadd',
                    name: 'knowledgeadd',
                    component: Knowledgeadd,
                    meta: {
                        title: "知识库"
                    }
                },
                {
                    path: '/mine/agency/knowledge',
                    name: 'knowledge',
                    component: Knowledge,
                    meta: {
                        title: "知识库"
                    }
                },
                {
                    path: '/mine/agency/dahomeNewestlist',
                    name: 'dahomeNewestlist',
                    component: DahomeNewestlist,
                    meta: {
                        title: "最新咨询"
                    }
                },
                {
                    path: '/mine/agency/dahomeNewest',
                    name: 'dahomeNewest',
                    component: DahomeNewest,
                    meta: {
                        title: "公告详情"
                    }
                },
                {
                    path: '/mine/agency/invoiceParticulars',
                    name: 'invoiceParticulars',
                    component: InvoiceParticulars,
                    meta: {
                        title: "发票管理"
                    }
                },
                {
                    path: '/mine/agency/invoiceadds',
                    name: 'invoiceadds',
                    component: Invoiceadds,
                    meta: {
                        title: "发票管理"
                    }
                },
                {
                    path: '/mine/agency/invoiceadd',
                    name: 'invoiceadd',
                    component: Invoiceadd,
                    meta: {
                        title: "发票管理"
                    }
                },
                {
                    path: '/mine/agency/invoiceand',
                    name: 'invoiceand',
                    component: Invoiceand,
                    meta: {
                        title: "发票管理"
                    }
                },
                {
                    path: '/mine/agency/invoicedss',
                    name: 'invoicedss',
                    component: Invoicedss,
                    meta: {
                        title: "发票申请"
                    }
                },
                {
                    path: '/mine/agency/invoice',
                    name: 'invoice',
                    component: Invoice,
                    meta: {
                        title: "发票申请"
                    }
                },
                {
                    path: '/mine/agency/apply',
                    name: 'apply',
                    component: Apply,
                    meta: {
                        title: "发票申请"
                    }
                },
                {
                    path: '/mine/agency/money',
                    name: 'money',
                    component: Money,
                    meta: {
                        title: "金额纪录"
                    }
                },
                {
                    path: '/mine/agency/notice',
                    name: 'notice',
                    component: NotiCe,
                    meta: {
                        title: "公告详情"
                    }
                },
                {
                    path: '/mine/agency/agent',
                    name: 'agent',
                    component: DaiDaililieb,
                    meta: {
                        title: "代理商列表"
                    }
                },
                {
                    path: '/mine/agency/tali',
                    name: 'tali',
                    component: DaRole,
                    meta: {
                        title: "跟踪记录"
                    }
                },
                {
                    path: '/mine/agency/resources',
                    name: 'resources',
                    component: Resources,
                    meta: {
                        title: "查看客户资源"
                    }
                },
                {
                    path: '/mine/agency/dahome',
                    name: 'dahome',
                    component: DaHome,
                    meta: {
                        title: "代理商首页"
                    }
                },
                {
                    path: '/mine/agency/allocation',
                    name: 'allocation',
                    component: DaiHoutaifenpei,
                    meta: {
                        title: "线索资源"
                    }
                },
                {
                    path: '/mine/agency/myProfile',
                    name: 'myProfile',
                    component: DaiWodeziliao,
                    meta: {
                        title: "我的资料"
                    }
                },
                {
                    path: '/mine/agency/traded',
                    name: 'traded',
                    component: DaiYichengjiao,
                    meta: {
                        title: "已成交"
                    }
                },
                {
                    path: '/mine/agency/prepayment',
                    name: 'prepayment',
                    component: DaiYufufei,
                    meta: {
                        title: "预付费"
                    }
                },
            ]
        },
        {
            path: '/Tagent',
            name: 'Zdaili',
            component: Zdaili,
            meta: {
                title: "总代理登录"
            }
        },
        {
            path: '/Tagent/general',
            name: 'general',
            meta: {
                title: "总代理后台"
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ('./views/general.vue'),
            children: [{
                    path: '/Tagent/general/noticesCategory',
                    name: 'noticesCategory',
                    component: NoticesCategory,
                    meta: {
                        title: "公告类别"
                    }
                },
                {
                    path: '/Tagent/general/invoiceListadds',
                    name: 'invoiceListadds',
                    component: InvoiceListadds,
                    meta: {
                        title: "发票管理详情"
                    }
                },
                {
                    path: '/Tagent/general/invoiceListadd',
                    name: 'invoiceListadd',
                    component: InvoiceListadd,
                    meta: {
                        title: "发票管理详情"
                    }
                },
                {
                    path: '/Tagent/general/invoiceList',
                    component: InvoiceList,
                    meta: {
                        title: "发票管理"
                    }
                },
                {
                    path: '/Tagent/general/record',
                    component: Record,
                    meta: {
                        title: "跟踪记录"
                    }
                },
                {
                    path: '/Tagent/general/seasuser',
                    component: Seasuser,
                    meta: {
                        title: "线索回收"
                    }
                },
                {
                    path: '/Tagent/general/notice',
                    component: Notice,
                    meta: {
                        title: "发布公告"
                    }
                },
                {
                    path: '/Tagent/general/apiWchat',
                    component: ApiWchat,
                    meta: {
                        title: "腾讯云设置"
                    }
                },
                {
                    path: '/Tagent/general/api',
                    component: ZdaiApi,
                    meta: {
                        title: "阿里云设置"
                    }
                },
                {
                    path: '/Tagent/general/role',
                    component: Role,
                    meta: {
                        title: "角色列表"
                    }
                },
                {
                    path: '/Tagent/general/Permission',
                    component: Permission,
                    meta: {
                        title: "权限列表"
                    }
                },
                {
                    path: '/Tagent/general/management',
                    component: management,
                    meta: {
                        title: "管理员列表"
                    }
                },
                {
                    path: '/Tagent/general/storage',
                    component: Zdaichuzi,
                    meta: {
                        title: "储值管理"
                    }
                },
                {
                    path: '/Tagent/general/agent',
                    component: ZdaiDailiyeji,
                    meta: {
                        title: "代理业绩"
                    }
                },
                {
                    path: '/Tagent/general/agency',
                    component: ZdaiDaililb,
                    meta: {
                        title: "代理列表"
                    }
                },
                {
                    path: '/Tagent/general/grade',
                    component: ZdaiGrade,
                    meta: {
                        title: "等级管理"
                    }
                },
                {
                    path: '/Tagent/general/basiceSet',
                    component: ZdaiJichushez,
                    meta: {
                        title: "基础设置"
                    }
                },
                {
                    path: '/Tagent/general/versionSet',
                    component: () =>
                        import ( /* webpackChunkName: "version" */ './views/zdaili/about/version.vue'),
                    meta: {
                        title: "版本管理"
                    }
                },
                {
                    path: '/Tagent/general/agencyList',
                    component: ZdaiLiebiao,
                    meta: {
                        title: "用户列表"
                    }
                },
                {
                    path: '/Tagent/general/authority',
                    component: ZdaiQuanguan,
                    meta: {
                        title: "权限管理"
                    }
                },
                {
                    path: '/Tagent/general/uphome',
                    component: ZdaiShouye,
                    meta: {
                        title: "首页"
                    }
                },
            ]
        },
    ]
})
export default router